import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import apiClient from '@/services/api-client';
import { ApiResponse, CountryItem, CountryState } from '@/services/types';
import { API_ENDPOINTS } from '@/utils/constants/end-points';

// ---------------------------
//  ASYNC THUNKS
// ---------------------------

// GET LIST
export const fetchTimeZone = createAsyncThunk<CountryItem[]>(
  'timezone/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get<ApiResponse<CountryItem[]>>(
        `${API_ENDPOINTS.ONBOARDING}/timezones`
      );
      return res.data.data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

// ---------------------------
//  SLICE
// ---------------------------

const initialState: CountryState = {
  data: [],
  loading: false,
  error: null,
};

const timeZoneSlice = createSlice({
  name: 'timezones',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH
    builder.addCase(fetchTimeZone.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchTimeZone.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchTimeZone.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default timeZoneSlice.reducer;
